import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Services } from "src/app/services/api.service";
import { ProfileService } from 'src/app/services/profile.service';
import { CommonModule } from '@angular/common';
import { ProfileSidebarComponent } from 'src/app/layout/profile-sidebar/profile-sidebar.component';
import { TranslateModule } from '@ngx-translate/core';
import { ListOfTransactionsComponent } from 'src/app/components/list-of-transactions/list-of-transactions.component';
import { ErrorMessageService } from 'src/app/services/error-message.util';
import { Router, RouterModule } from '@angular/router';
import { EventsService } from 'src/app/services/getEvents';
import { Subscription } from 'rxjs';
import { EventsListComponent } from 'src/app/components/events-list/events-list.component';
import { NotificationComponent } from 'src/app/components/notification/notification.component';
import { getNotificationConfig } from 'src/app/utils/notification-config.util';

@Component({
  selector: 'app-user-profile',
  templateUrl:  `./${environment.pageFolder}/user-profile.${environment.pageFolder}.component.html`,
  styleUrls:  [`./${environment.pageFolder}/user-profile.${environment.pageFolder}.component.sass`],
  standalone: true,
  imports: [CommonModule, ProfileSidebarComponent, TranslateModule, ListOfTransactionsComponent, RouterModule, EventsListComponent, NotificationComponent]
})

export class UserProfileComponent implements OnInit {
  loader = document.getElementById("loader-container");
  showCurrentTickets: boolean = true;
  transactions:any = [];
  nextEvents:any = [];
  previousEvents:any = [];
  noTicketsMessage: string = "";
  areTransactionsLoaded: boolean = false;
  envConnId = environment.connId;
  private subscriptions = new Subscription();
  allEvents: any;
  showNotification: boolean = false;
  bodyText: string = '';

  constructor(
    public Services: Services,
    private readonly profileService: ProfileService,
    private readonly errorMessageService: ErrorMessageService,
    private readonly eventsService: EventsService,
    private readonly router: Router,
  ){}

  ngOnInit(): void {
    this.showNotificationModal();
    this.getUserTransactions();
  }
  
  private getUserTransactions() {
    this.loader!.style.display = "flex";    

    this.profileService.getTransactions().pipe().subscribe({
      next: (data: any) => {
        this.transactions = data.data;

        this.areTransactionsLoaded = true;
        this.transactions.filter((item: any) => {
          let date: any = new Date(item.events[0]?.date);
          date.getTime() > Date.now() ? this.nextEvents.push(item) : this.previousEvents.push(item);
        });

        if (this.transactions.length === 0) {
          this.subscriptions.add(
            this.eventsService.getEvents().subscribe((response: any) => {
              this.allEvents = response.data;
              this.allEvents = this.allEvents.filter((event: any) => event.isVisible !== false && event.actions?.length > 0);
              this.loader!.style.display = "none";
            })
          );
          this.noTicketsMessage = this.errorMessageService.getErrorMessage('noTickets');
        } else {
          this.loader!.style.display = "none";
        }
      },
      error: (error: any) => {
        if (error.status === 401) {
          this.Services.logout();
        }
      }
    });
  }

  changeShowCurrentTickets() {
    this.showCurrentTickets = !this.showCurrentTickets;
  }

  private showNotificationModal(): void {
    const notificationConfig = getNotificationConfig(this.router.url, 'TICKETS');
    this.showNotification = notificationConfig.show;
    this.bodyText = notificationConfig.bodyTextKey;
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
